import {isValid} from 'date-fns';
import {getTimeFromDate} from 'platform/components';

import {parseDate, Nullish} from 'shared/web';

// todo: use a 12-hour format when the user's locale requires it (T20-57261, T20-57262)
export function getDefaultCompletionAtTime(date: string | Nullish) {
  if (!date) {
    return;
  }

  const parsed = parseDate(date);

  return isValid(parsed) ? getTimeFromDate(parsed) : undefined;
}
